export default __webpack_public_path__ + "static/media/investimento.2c683e4c.png";